import * as React from "react";
import get from "lodash/get";

import "./PointsExpiry.css";
import { ComponentBase, ComponentBaseProps } from "../ComponentBase";
import { getLedgerHead, getRewardRequestStatus } from "../../reducers/methods";
import { RequestStatus } from "../../types/requestStatus";
import { currencySymbols } from "../../utils/currencies";
import { formatUserFacingNumber } from "../../utils/number";

export interface PointsExpiryProps extends ComponentBaseProps {
  action: string;
  center: string;
  classNames: string;
  label: string;
  ledgerHead: ReturnType<typeof getLedgerHead>;
  onClick: () => void;
  requestStatus: ReturnType<typeof getRewardRequestStatus>;
  currency?: string;
  style: { [styleProp: string]: string };
}

// When in editing mode, default the expiring points to 19 as a placeholder value for preview;
// otherwise, use the actual value from ledgerHead, defaulting to 0 if not available.
function formatExpiringPoints(
  currencySymbol: any,
  ledgerHead: ReturnType<typeof getLedgerHead>,
  isEditing: boolean
) {
  const points = formatUserFacingNumber(
    Number(get(ledgerHead, "expiringPoints", isEditing ? 19 : 0))
  );

  return `${currencySymbol}${points}`;
}

export class PointsExpiry extends ComponentBase<PointsExpiryProps> {
  render() {
    const {
      classNames,
      data,
      label = "points_expiry",
      isEditing,
      ledgerHead,
      requestStatus,
      currency = "USD",
    } = this.props;

    const isCustomerAuthenticated = get(data, "customer.authenticated", false);
    const getLedgerRequestStatus = get(
      requestStatus,
      "getLedger"
    ) as RequestStatus;

    if (!isCustomerAuthenticated && !isEditing) {
      return null;
    }

    const currencySymbol: string =
      currency === "loyalty" ? "" : get(currencySymbols, currency, currency);

    return (
      <div
        id={this.props.configName}
        onDragStart={this.onDragStart}
        onAnimationEnd={this.resetAnimation}
        style={this.props.style}
        className={`PointsExpiry-container ${classNames || ""} ${this.state.animationClass}`}
        aria-label={label}
        ref={(component) => (this.component = component)}
      >
        {getLedgerRequestStatus === "REQUESTING" && <span>...</span>}
        {(getLedgerRequestStatus === "SUCCESS" || isEditing) &&
          formatExpiringPoints(currencySymbol, ledgerHead, isEditing)}
      </div>
    );
  }
}
